module.exports = __webpack_public_path__ + "img/eyein-partner-videotron.f1cbd8d7.webp";